module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "branch"
  }, [_c('div', {
    staticClass: "ui radio"
  }, [_c('span', [(_vm.checked[parseInt(_vm.branch.id_category, 10)]) ? _c('i', {
    staticClass: "check circle outline icon",
    on: {
      "click": function($event) {
        return _vm.handleCheck(_vm.branch)
      }
    }
  }) : _c('i', {
    staticClass: "circle outline icon",
    on: {
      "click": function($event) {
        return _vm.handleCheck(_vm.branch)
      }
    }
  })]), _vm._v(" "), _c('label', {
    on: {
      "click": _vm.toggleShowChildren
    }
  }, [(_vm.children) ? _c('span', [(!_vm.showChildren) ? _c('i', {
    staticClass: "folder icon"
  }) : _vm._e(), _vm._v(" "), (_vm.showChildren) ? _c('i', {
    staticClass: "folder open icon"
  }) : _vm._e()]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.branch.id_category + '. ' + _vm.branch.name) + "\n    ")])]), _vm._v(" "), (_vm.children && _vm.showChildren) ? _c('ul', {
    staticClass: "nested"
  }, _vm._l((_vm.children), function(child) {
    return _c('branch', {
      key: child.id_category,
      attrs: {
        "branch": child,
        "handle-check": _vm.handleCheck,
        "checked-category": _vm.checkedCategory
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce11b64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Branch.vue
// module id = 487
// module chunks = 1